
let styles = {
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        color:'black'
    },
    text: {
        marginBotton: '10px'
    },
    main_header: {
        padding: '1%',
        marginBottom: '3%',
        backgroundColor: '#32B6A7',
    },
    item_header: {
        fontWeight: 600,
        paddingLeft: '2%',
        width:'40%'

    },
    input: {
        width: '50%',
        height: 25,
        color:'black',
        marginLeft:'1%'
    },
    items: {
        display:'flex',
        flexDirection:'row',
        margin: '0.5%',
    },
    main_items: {
        display:'flex',
        flexDirection:'row',
        margin: '0.5%',
        width:'100%',
    },
    textbox: {
        height: 75,
        color: 'black'
    },
    item_body: {
        padding: '3px ',
        color: 'black',
        width:'60%',
        float:'left'
    }
    

  }


  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/responseLeads/style.js